import { render } from "./EventCard.vue?vue&type=template&id=2bac3454&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=2bac3454&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bac3454"

export default script